import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CSRFProvider } from './context/CSRFcontext';
import AppTheme from './context/ThemeProvider.js';
import { registerServiceWorker } from './swRegistration.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


  <BrowserRouter>
    <CSRFProvider>
      <AppTheme>
        <App />
      </AppTheme>
    </CSRFProvider>
  </BrowserRouter>

);
registerServiceWorker();
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
